import { useQuery } from '@tanstack/react-query';
import {
  HostCandidateQueryKeys,
  getCandidateInfo,
} from 'flux/clients/candidate';
import { useAccount } from '~/authentication/store';

function useCandidateInfo() {
  const { account } = useAccount();
  const accountId = account?.id;

  const queryData = useQuery(
    [...HostCandidateQueryKeys, accountId],
    () => getCandidateInfo(accountId),
    {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchOnMount: false,
      enabled: !!accountId,
    },
  );

  return queryData;
}

export default useCandidateInfo;
